var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClickAndCollectinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 1a4 4 0 0 1 3.995 3.8L16 5v1h1.124a2 2 0 0 1 1.956 1.58l.027.156 1.733 13a2 2 0 0 1-1.718 2.246 2 2 0 0 1-.264.018H5.142a2 2 0 0 1-1.982-2.264l1.733-13A2 2 0 0 1 6.876 6h1.123L8 5a4 4 0 0 1 4-4m5.124 7h-1.125L16 11h-2V8h-4v3H8V8H6.875L5.142 21h13.716zM12 3a2 2 0 0 0-1.995 1.85L10 5v1h4V5a2 2 0 0 0-2-2"
})));
export default SvgClickAndCollectinline;